module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.toggle(_vm.keyName, $event)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.direction === 'asc') ? _c('i', {
    staticClass: "small fas fa-long-arrow-alt-down glyphicon glyphicon-arrow-down"
  }) : _c('span', [(_vm.direction === 'desc') ? _c('i', {
    staticClass: "small fas fa-long-arrow-alt-up glyphicon glyphicon-arrow-up"
  }) : _vm._e()])], 2), _vm._v(" "), (_vm.direction.length > 0) ? _c('a', {
    staticClass: "btn-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.reset(_vm.keyName, $event)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times glyphicon glyphicon-remove"
  })]) : _c('span', {
    staticClass: "small fas fa-arrows-alt-v glyphicon glyphicon-resize-vertical"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bd57992c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sorter.vue
// module id = 316
// module chunks = 2